import {
    formatDateTimeLong,
    formatTime,
    minutesToDuration,
} from '~/lib/DateTime.js';
import { SelectionImage } from '~/components/forms/questions/components/SelectionBlock.jsx';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import SeriesTime from '~/components/forms/questions/scheduling/SeriesTime';
import ClassDescription, {
    ClassSpotsLeft,
    ClassTitle,
    isInstanceSelected,
} from '~/components/forms/questions/scheduling/ClassDescription';
import ClassBookButton from '~/components/forms/questions/scheduling/ClassBookButton';
import {
    clientFormatDateTimeLong,
    clientFormatTime,
} from '~/public/lib/ClientDateTime.js';
import { FormPart, FormStateName, part, state } from '~/lib/FormCssApi';

const ClassRow = ({
    instance,
    isFirst,
    onSelect,
    onRemove,
    settings,
    isSelected,
    clientTz,
    showDate,
    asPanel,
}) => {
    const type = instance.event_type;

    return (
        <div
            {...part(FormPart.CLASS_BLOCK)}
            {...state(
                isSelected && FormStateName.SELECTED,
                instance.spots_left <= 0 && FormStateName.FULL,
            )}
            className={
                asPanel
                    ? 'bg-white rounded-lg p-4'
                    : `${!isFirst ? 'border-t' : ''} py-4 flex-1 pr-6`
            }
        >
            <div className="flex">
                {!!type.image && (
                    <SelectionImage
                        image={type.image}
                        className="my-0 mt-0"
                        part={FormPart.CLASS_IMAGE}
                    />
                )}
                <div>
                    <div {...part(FormPart.CLASS_TIME)}>
                        {showDate
                            ? clientFormatDateTimeLong(instance.start, clientTz)
                            : clientFormatTime(instance.start, clientTz)}
                        {!settings?.hideDuration && (
                            <> · {minutesToDuration(type.duration)}</>
                        )}
                    </div>
                    <ClassTitle type={type} settings={settings} instance={instance} />
                </div>
                {/*<div className="flex-1 flex items-start justify-between">*/}
                {/*    <div className="sm:flex items-start">*/}
                {/*        {!!type.image && (*/}
                {/*            <SelectionImage*/}
                {/*                image={type.image}*/}
                {/*                className="my-0 mt-0"*/}
                {/*            />*/}
                {/*        )}*/}
                {/*        <ClassDescription*/}
                {/*            instance={instance}*/}
                {/*            type={type}*/}
                {/*            className="hidden sm:block"*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>
            <ClassDescription instance={instance} type={type} className="" settings={settings} truncateSeriesTimes={true} clientTz={clientTz} />
            <div className="flex items-center min-w-24 mt-2">
                <ClassBookButton
                    instance={instance}
                    onSelect={onSelect}
                    onRemove={onRemove}
                    isSelected={isSelected}
                    settings={settings}
                />

                <ClassSpotsLeft
                    instance={instance}
                    settings={settings}
                    className="ml-2"
                />

                {!settings?.hideBookableResource &&
                    !!instance.bookable_resource?.name && (
                        <div
                            {...part(FormPart.CLASS_RESOURCE)}
                            className="ml-1 text-gray-500 text-sm"
                        >
                            with {instance.bookable_resource.name}
                        </div>
                    )}
            </div>
        </div>
    );
};

const ClassList = ({
    classes,
    settings,
    onSelectClass,
    onRemoveClass,
    selectedClasses,
    clientTz,
    showDate,
    asPanels,
}) => {
    return (
        <div
            {...part(FormPart.CLASS_LIST)}
            className={
                asPanels
                    ? 'flex flex-col gap-4 mt-4'
                    : 'bg-white rounded-lg pl-6 mt-4'
            }
        >
            {classes.map((i, idx) => (
                <ClassRow
                    key={i.id}
                    isFirst={idx === 0}
                    instance={i}
                    settings={settings}
                    isSelected={isInstanceSelected(i, selectedClasses)}
                    onSelect={() => onSelectClass(i)}
                    onRemove={() => onRemoveClass(i)}
                    clientTz={clientTz}
                    showDate={showDate}
                    asPanel={asPanels}
                />
            ))}
        </div>
    );
};

export default ClassList;
